import { useEffect, useState } from "react";
import axios from "axios";
import { ArrowLeft, RefreshCw, CheckCircle2, XCircle, Clock, FlaskConical, Send, MousePointerClick } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CampaignDetail({ campaignId, onBack }) {
  const [c, setC] = useState(null);
  const [links, setLinks] = useState(null);

  const load = () => {
    axios.get(`${API}/v1/campaigns/${campaignId}`).then((r) => setC(r.data)).catch(() => {});
    axios.get(`${API}/v1/campaigns/${campaignId}/links`).then((r) => setLinks(r.data)).catch(() => {});
  };
  useEffect(() => {
    load();
    const t = setInterval(load, 3000);
    return () => clearInterval(t);
  }, [campaignId]);

  if (!c) return <div className="panel"><div className="p-body"><RefreshCw size={16} className="spin" /> Loading…</div></div>;

  const s = c.stats;
  const statusClass = c.status === "COMPLETED" ? "b-delivered" : c.status === "FAILED" ? "b-bounced" : c.status === "SCHEDULED" ? "b-deferred" : "b-sent";

  return (
    <div data-testid="campaign-detail">
      <button className="btn ghost" data-testid="detail-back-btn" onClick={onBack} style={{ marginBottom: 16 }}><ArrowLeft size={15} /> All campaigns</button>
      <div className="panel"><div className="p-head"><Send size={15} /><h3>{c.name}</h3>
        <span className={`badge ${statusClass}`} data-testid="detail-status">{c.status}</span>
        {c.isDryRun && <span className="badge b-deferred"><FlaskConical size={11} /> DRY RUN</span>}
      </div>
        <div className="p-body">
          <div className="detail-meta"><span>{c.fromName} &lt;{c.fromEmail}&gt;</span><span>·</span><span>{c.subject}</span>{c.scheduledAt && <><span>·</span><span><Clock size={11} /> {new Date(c.scheduledAt).toLocaleString()}</span></>}</div>
          <div className="progress-track" data-testid="detail-progress"><div className="progress-fill" style={{ width: `${c.progressPercent}%` }} /></div>
          <div className="progress-label">{c.progressPercent}% · {s.processed}/{s.total} processed</div>
          <div className="metrics" style={{ marginTop: 18, gridTemplateColumns: "repeat(6,1fr)" }}>
            <div className="metric"><span className="m-val" data-testid="stat-total">{s.total}</span><span className="m-lbl">Recipients</span></div>
            <div className="metric"><span className="m-val" style={{ color: "var(--green)" }} data-testid="stat-sent">{s.sent}</span><span className="m-lbl">Sent</span></div>
            <div className="metric"><span className="m-val" style={{ color: "var(--amber)" }} data-testid="stat-pending">{s.pending}</span><span className="m-lbl">Pending</span></div>
            <div className="metric"><span className="m-val" style={{ color: "var(--red)" }} data-testid="stat-failed">{s.failed}</span><span className="m-lbl">Failed / Bounced</span></div>
            <div className="metric"><span className="m-val" style={{ color: "var(--blue)" }} data-testid="stat-opens">{s.opens ?? 0} <small className="rate">{s.openRate ?? 0}%</small></span><span className="m-lbl">Opens</span></div>
            <div className="metric"><span className="m-val" style={{ color: "var(--purple, #9d8cff)" }} data-testid="stat-clicks">{s.clicks ?? 0} <small className="rate">{s.clickRate ?? 0}%</small></span><span className="m-lbl">Clicks</span></div>
          </div>
        </div>
      </div>

      {links && links.links.length > 0 && (
        <div className="panel" data-testid="link-heatmap" style={{ marginTop: 16 }}>
          <div className="p-head"><MousePointerClick size={15} /><h3>Top Links</h3><span className="hint">{links.totalClicks} clicks</span></div>
          <div className="p-body">
            {links.links.map((l, i) => {
              const top = links.links[0].clicks || 1;
              const pct = Math.max(4, Math.round((l.clicks / top) * 100));
              return (
                <div key={i} className="heat-row" data-testid={`link-row-${i}`} style={{ marginBottom: 12 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, fontSize: 13, marginBottom: 5 }}>
                    <a href={l.url} target="_blank" rel="noreferrer" title={l.url} style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "68%", color: "var(--blue)" }}>{l.url}</a>
                    <span className="mono-strong" style={{ whiteSpace: "nowrap" }}>{l.clicks} <small style={{ color: "var(--txt-faint)" }}>· {l.uniqueClicks} uniq</small></span>
                  </div>
                  <div className="progress-track"><div className="progress-fill" style={{ width: `${pct}%` }} /></div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
